// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Belt_MutableStack = require("rescript/lib/js/belt_MutableStack.js");
var Expln_utils_common = require("./Expln_utils_common.bs.js");

function log(prim) {
  console.log(prim);
}

function log2(prim0, prim1) {
  console.log(prim0, prim1);
}

function traverseTree(context, root, getChildren, preProcess, $$process, postProcess, param) {
  var hasPreProcess = Belt_Option.isSome(preProcess);
  var hasProcess = Belt_Option.isSome($$process);
  var hasPostProcess = Belt_Option.isSome(postProcess);
  var nodesToProcess = Belt_MutableStack.make(undefined);
  var res;
  Belt_MutableStack.push(nodesToProcess, {
        node: root,
        nodesToPostProcess: hasPostProcess ? [root] : undefined
      });
  while(!Belt_MutableStack.isEmpty(nodesToProcess) && Belt_Option.isNone(res)) {
    var currNode = Belt_MutableStack.pop(nodesToProcess);
    if (currNode !== undefined) {
      if (hasPreProcess) {
        res = Belt_Option.flatMap(preProcess, (function(currNode){
            return function (f) {
              return Curry._2(f, context, currNode.node);
            }
            }(currNode)));
      }
      if (hasProcess && Belt_Option.isNone(res)) {
        res = Belt_Option.flatMap($$process, (function(currNode){
            return function (f) {
              return Curry._2(f, context, currNode.node);
            }
            }(currNode)));
      }
      if (Belt_Option.isNone(res)) {
        var children = Curry._2(getChildren, context, currNode.node);
        var exit = 0;
        if (children !== undefined && children.length !== 0) {
          var maxChildIdx = children.length - 1 | 0;
          for(var i = maxChildIdx; i >= 0; --i){
            var tmp;
            if (hasPostProcess) {
              if (i === maxChildIdx) {
                var nodes = currNode.nodesToPostProcess;
                if (nodes !== undefined) {
                  nodes.push(Caml_array.get(children, i));
                  tmp = nodes;
                } else {
                  throw {
                        RE_EXN_ID: Expln_utils_common.ExplnUtilsException,
                        _1: {
                          msg: "this case is not possible, because each node has itself in its nodesToPostProcess (2)"
                        },
                        Error: new Error()
                      };
                }
              } else {
                tmp = [Caml_array.get(children, i)];
              }
            } else {
              tmp = undefined;
            }
            Belt_MutableStack.push(nodesToProcess, {
                  node: Caml_array.get(children, i),
                  nodesToPostProcess: tmp
                });
          }
        } else {
          exit = 1;
        }
        if (exit === 1 && hasPostProcess) {
          var nodes$1 = currNode.nodesToPostProcess;
          if (nodes$1 !== undefined) {
            var i$1 = {
              contents: nodes$1.length - 1 | 0
            };
            while(i$1.contents >= 0 && Belt_Option.isNone(res)) {
              res = Belt_Option.flatMap(postProcess, (function(i$1,nodes$1){
                  return function (f) {
                    return Curry._2(f, context, Caml_array.get(nodes$1, i$1.contents));
                  }
                  }(i$1,nodes$1)));
              i$1.contents = i$1.contents - 1 | 0;
            };
          } else {
            throw {
                  RE_EXN_ID: Expln_utils_common.ExplnUtilsException,
                  _1: {
                    msg: "this case is not possible, because each node has itself in its nodesToPostProcess (1)"
                  },
                  Error: new Error()
                };
          }
        }
        
      }
      
    }
    
  };
  return [
          context,
          res
        ];
}

exports.log = log;
exports.log2 = log2;
exports.traverseTree = traverseTree;
/* No side effect */
